var routeTable = require('../table');
module.exports = routeTable(
	// universal
	{
		'': 'showWallet',	// default wallet view
		'card(/:id)(/:action)': 'card',
		'savedOffer/:id': 'savedOffer',
		'balance': 'balance',
		'padDetails': 'padDetails',
		'enrollInPAD': 'enrollInPAD',
		'updatePAD': 'updatePAD',
		'padFlow': 'padFlow',
		'creditProduct/:creditProduct': 'creditProduct',	// ex: /myaccount/wallet/creditProduct/bml
		'withdraw(/:section)': 'withdraw',					// ex: /myaccount/wallet/withdraw/fromDetails
		'addFunds(/:section)': 'addFunds',
		'repayFunds': 'repayBalance',				// ex: /myaccount/wallet/addFunds/fromDetails
		'zeroBalance': 'zeroBalance',
		'giftCard/:id': 'giftCard',
		'merchantGC/:id(/:action)': 'merchantGC',
		'confirmBankInstantly/:id': 'confirmBankInstantly',
		'showFABLogin/:id': 'showFABLogin',
		'addConfirm/success': 'showFABSuccess',
		'addBank/saveBank': 'addBankAfterAuthflow',
		'confirmbank': 'showUnconfirmedBanks',
		'walletpreferences': 'showSettingsWalletPreferences',
		'confirmEmail': 'confirmEmail'
	},
	// clientOnly
	{
		'add/:action(/*returnUrl)(?fromForm=:fromForm)': 'add',	/* ex: /myaccount/wallet/add */
		'bank(/:id)(/*fromUrl)': 'bank'
	},
	// serverOnly
	[
		'add/:action?',
		'bank/:id?'
	]
);



//////////////////
// WEBPACK FOOTER
// ./routes/tables/wallet-table.js
// module id = 864
// module chunks = 0